import * as React from 'react';

import { isdeviceUpToTablet } from '../../shared/helpers/responsive';

export interface HOCIsMobileState {
  isMobile: boolean;
  handlerMobileDevice: () => void;
}

const HOCIsMobile = (Component: any) =>
  class extends React.Component<any, HOCIsMobileState> {
    state = { isMobile: false, handlerMobileDevice: isdeviceUpToTablet };

    componentWillUnmount() {
      window.removeEventListener('resize', this.updateMobileState);
    }

    componentDidMount() {
      this.updateMobileState();
      window.addEventListener('resize', this.updateMobileState);
    }

    setHandlerOnResize = (handler: any) => {
      this.setState({ handlerMobileDevice: handler }, () => {
        this.updateMobileState();
      });
    };

    updateMobileState = () => {
      this.setState({ isMobile: this.state.handlerMobileDevice() });
    };

    render() {
      return <Component {...this.props} setHandlerOnResize={this.setHandlerOnResize} isMobile={this.state.isMobile} />;
    }
  };

export default HOCIsMobile;
